import React from 'react';
import { useMigration } from '../hooks/useMigration';
import { MigrationProgress } from './MigrationProgress';

interface MigrationWrapperProps {
  children: React.ReactNode;
}

export const MigrationWrapper: React.FC<MigrationWrapperProps> = ({ children }) => {
  const { isMigrating } = useMigration();

  return (
    <>
      <MigrationProgress 
        visible={isMigrating} 
        onComplete={() => {
          window.location.reload();
        }}
      />
      {children}
    </>
  );
};
